<template>
    <requisicao-form
        v-if="requisicao"
        operacao="A"
        @salvar="salvar($event)"
        :errosPai="erros"
        :requisicao="requisicao"
        :naoPermiteAtualizar="naoPermiteAtualizar"
    ></requisicao-form>
</template>
<script>
import RequisicaoForm from './RequisicaoForm'
import RequisicoesServicos from './RequisicoesServicos'
import { situacaoRequisicao } from './SituacaoRequisicao'

export default {
    data() {
        return {
            erros: [],
            requisicao: null,
            naoPermiteAtualizar: false
        }
    },

    mounted() {
        this.obterRequisicao()
    },

    methods: {
        obterRequisicao() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterPorId(
                this.$route.params.idRequisicao
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.processarRequisicao(response.data)
                    } else {
                        this.erros = ['Erro ao obter requisição']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        processarRequisicao(data) {
            if (
                data.codSituacao == situacaoRequisicao.CONCLUIDA ||
                data.codSituacao == situacaoRequisicao.AUTORIZADA ||
                data.codSituacao == situacaoRequisicao.FINALIZADA ||
                data.codSituacao == situacaoRequisicao.ENVIO_REGISTRADO ||
                data.codSituacao == situacaoRequisicao.CANCELADA
            ) {
                this.erros = ['Essa requisição não pode ser atualizada']
                this.naoPermiteAtualizar = true
            }
            this.requisicao = data
        },

        salvar(requisicao) {
            this.$store.dispatch('addRequest')
            requisicao.idRequisicao = this.$route.params.idRequisicao
            RequisicoesServicos.atualizarRequisicao(requisicao).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.toDetalhar()
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        toDetalhar() {
            this.$router.push({
                name: 'Contratos_Requisicoes_Detalhar',
                params: {
                    idRequisicao: this.$route.params.idRequisicao
                }
            })
        }
    },

    components: {
        RequisicaoForm
    }
}
</script>